import "./App.css";
import Layout from "./layout/Layout";

const App = () => {
  return <Layout />;
};

export default App;
